'use strict';

var React = require('react');

var SvgEnvelopeMajor = function SvgEnvelopeMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 16.5v-13c0-.8.7-1.5 1.5-1.5h17c.8 0 1.5.7 1.5 1.5v13c0 .8-.7 1.5-1.5 1.5h-17c-.8 0-1.5-.7-1.5-1.5zm18-1.2-3-1.8v-6.9l3-1.867v10.567zm-2.667.7-1.833-1.1c-.3-.2-.5-.5-.5-.9v-8c0-.4.2-.7.5-.9l1.833-1.1h-13.333v12h13.333zm-11.333-8h4v2h-4v-2zm6 4h-6v2h6v-2z"
  }));
};

exports.SvgEnvelopeMajor = SvgEnvelopeMajor;
